import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { BaseEntity } from '../base/BaseEntity';
import { CommentService } from '../services/comment.service';
import {Comment} from '../models/comment.model';
import { IPageInfo } from '../base/interfaces/IPageInfo';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ConfirmComponent } from '../dialogs/confirm/confirm.component';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css']
})
export class CommentComponent  implements OnChanges, OnInit {

  public tools = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
        'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
        'LowerCase', 'UpperCase', '|',
        'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
        'Outdent', 'Indent', '|',
        'ClearFormat',
        'SourceCode', '|', 'Undo', 'Redo']
  };

  @Input() parent: BaseEntity;
  @Output() numberOfCommentsChanged = new EventEmitter<number>();
  
  public newComment: Comment = new Comment();
  public comments: Comment[] = [];
  public listClass = '.comment-list';  
  displayedColumns = ['userName', 'note'];
  inlineEditCommentId: string;
  private pageInfo: IPageInfo;  
  constructor(
    private commentService: CommentService,
    private changeDetectorRefs: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
   }
   ngOnInit(): void {
    this.initComments();
  }

  private initComments() {
    if (this.parent && this.parent.id) {
      this.commentService.GetAllByParent(this.parent.id, 'created', 'desc', 1, 10).subscribe(data => {
        this.comments = data.payload;
        this.pageInfo = data.pageInfo;
        this.numberOfCommentsChanged.emit(this.comments.length);
      });
      this.CreateNew();
    }
    this.changeDetectorRefs.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.parent) {
      if (changes.parent.currentValue !== changes.parent.previousValue) {
        if (changes.parent.currentValue && changes.parent.previousValue) {
          if (changes.parent.previousValue.id !== changes.parent.currentValue.id ) {
            this.initComments();
          }
        } else {
          this.initComments();
        }
      }
    }
  }

  OnShow() {
  }
  OnDelete() {
  }
  CreateNew() {
    this.newComment = new Comment(this.parent.id);
  }
  OnNew() {
    if (this.parent) {
      this.newComment.parentId = this.parent.id;
    }
    if (!this.newComment.note) {
      return;
    }
    this.commentService.Create(this.newComment).subscribe(() => {
      this.initComments();
    });
  }
  OnEditComment(commentId: string) {

    this.inlineEditCommentId = commentId;
  }
  OnSaveComment(comment: Comment) {
    this.commentService.Update(comment).subscribe(() => {
      this.inlineEditCommentId = null;
      this.initComments();
    });
  }
  OnDeleteComment(commentId: string) {
    this.ConrimDelete(commentId).subscribe((ret) => {
      if (ret) {
        this.commentService.Delete(commentId).subscribe(() => {
          this.initComments();
        });
      }
    });
  }
  OnCancelCommentEdit() {
    this.inlineEditCommentId = null;
  }
  onScroll() {
    if (this.pageInfo) {
      if (this.pageInfo.page < this.pageInfo.pageCount) {
        const page = this.pageInfo.page + 1;
        if (this.parent && this.parent.id) {
          this.commentService.GetAllByParent(this.parent.id, 'created', 'desc', page, 10).subscribe(data => {
            const current = this.comments;
            this.comments = [...current, ...(data.payload)];
            this.pageInfo = data.pageInfo;
          });
        }
      }
    }
  }
  private ConrimDelete(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dialogMessages.deleteRecord'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
}
